export function info (...args: unknown[]): void {
  return console.info(...args);
}

export function warn (...args: unknown[]): void {
  return console.warn(...args);
}
